module.exports = __webpack_public_path__ + "img/product_62.e37d66d.svg";